import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Career } from 'src/app/interfaces/career';
import { CareerService } from 'src/app/services/career.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css']
})
export class CareerComponent implements OnInit {
  listCareers: Career[] = [];
  loading = false;

  constructor(
    private _careerService: CareerService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListCareers();
  }

  getListCareers() {
    this.loading = true;

    this._careerService.getListCareers().subscribe({
      next: (data: Career[]) => {
        this.listCareers = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de carreras:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteCareer(id: number) {
    this.loading = true;
    this._careerService.deleteCareer(id).subscribe({
      next: () => {
        this.getListCareers();
        this.toastr.warning('La carrera fue eliminada con exito', 'Carrera eliminada');
      },
      error: (error) => {
        console.error('Error al eliminar la carrera:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
